import { Pipe, PipeTransform } from '@angular/core';
import { DealershipOverview } from '../models/dealership.model';

@Pipe({
    name: 'filterDealerTable'
})
export class FilterDealerTablePipe implements PipeTransform {

    transform(dealer: DealershipOverview[], filterText: string) {
        if (dealer == null)
            return null;
        return dealer.filter(c => {
            if (c.DealershipName != null && c.DealershipName.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
                return true;
            else if (c.DealershipGroupName != null && c.DealershipGroupName.toLowerCase().indexOf(filterText.toLowerCase()) !== -1)
                return true;
            return false;
        });
    }

}
